import React from 'react';
import { BrowserRouter, Link } from 'react-router-dom';
import FooterLogo from '../img/footer-logo.png';
import testimonialsData from '../PostData/testimonialsData';
import workData from '../PostData/workData';
import blogData from '../PostData/blogData';

const Footer = () => {
    const todayYear = new Date().getFullYear();

    return (
        <footer id="footer">
            <div className="container">
                <BrowserRouter forceRefresh={true}><Link to="/" className="footerLogo">
                    <img src={FooterLogo} alt="Footer Logo" />
                </Link></BrowserRouter> {/* Footer Logo */}

                <ul className="footerNav">
                    <li className="footerNavItem"><Link to="/about-me" className="footerLink">About</Link></li>
                    {workData.length !== 0 && <li className="footerNavItem">
                        <BrowserRouter forceRefresh={true}>
                            <Link to="/latest-work" className="footerLink">Latest Work</Link>
                        </BrowserRouter>
                    </li>}
                    {testimonialsData.length !== 0 && <li className="footerNavItem"><Link to="/testimonials" className="footerLink">Testimonials</Link></li>}
                    {blogData.length !== 0 && <li className="footerNavItem"><Link to="/blog" className="footerLink">Blog</Link></li>}
                </ul> {/* Footer Nav */}

                <div>
                    <p className="footerCopyright">Copyright © 2019- {todayYear} by <BrowserRouter forceRefresh={true}><Link to="/" className="footerLink">Wasek Bellah</Link></BrowserRouter>. All Right Reserved.</p>
                </div> {/* Footer Copyright */}
            </div> {/* Container */}
        </footer> // Footer
    );
};

export default Footer;